import { Promise } from "es6-promise";
import { getRedirectCandidateTypes, getRedirectCandidateTemplate, ERedirectCandidateType } from "./index";
import store from "../store/store";
import types from "../store/types";
export class RedirectHelper {

    public static loadCandidateTemplates = () : Promise<void> => {

        let promise = new Promise<void>((resolve, reject) => {

            getRedirectCandidateTypes().then(candidateTypeOptions => {
                
                store.dispatch({
                    type: types.SET_REDIRECT_CANDIDATE_TYPE_OPTIONS,
                    candidateTypeOptions: candidateTypeOptions
                });

                Promise
                .all(candidateTypeOptions.map(candidateType => {
                    return getRedirectCandidateTemplate(candidateType.key).then(candidateTemplate => {
                        store.dispatch({
                            type: types.ADD_REDIRECT_CANDIDATE_TEMPLATE,
                            candidateType: candidateType.key,
                            candidateTemplate: candidateTemplate
                        });
                    })
                }))
                .then(() => resolve())
                .catch(err => reject(err));            
            });
        });

        return promise;
    }
}


// WEBPACK FOOTER //
// ./source/ts/helpers/redirect.ts